export const SFH_DEFAULT_ORDER_LIMIT = 100_000;
export const SFH_KILO_GOLD_BAR_ORDER_LIMIT = 175_000;
export const SFH_HIGH_VALUE_SHIPPING_NOTICE_THRESHOLD = 25_000;

// MetalType can be the string label ("Gold") or the numeric API enum (Gold=1).
const GOLD_METAL_LABELS = new Set(['gold', '1']);

const isGoldMetalType = (metalType) =>
  GOLD_METAL_LABELS.has(
    String(metalType ?? '')
      .trim()
      .toLowerCase(),
  );

const isOneKiloWeight = (weightCaption) => {
  const normalized = String(weightCaption ?? '')
    .trim()
    .toLowerCase();
  return /^1[\s-]?kilo\b/.test(normalized);
};

export const isOneKiloGoldBar = (selectedHit) =>
  isGoldMetalType(selectedHit?.MetalType) &&
  isOneKiloWeight(selectedHit?.WeightCaption);

export const resolveSfhOrderLimit = (selectedHit) =>
  isOneKiloGoldBar(selectedHit)
    ? SFH_KILO_GOLD_BAR_ORDER_LIMIT
    : SFH_DEFAULT_ORDER_LIMIT;
